import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDeviceType from "../../custom-hooks/DeviceType";
import {
  destructStatusData,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
} from "../../utils/statusConstants";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import SearchSelectDropdown from "../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import { searchIcon } from "../../assets";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import { componentKey, setCloseOrderDialog } from "./orderSlice";
import { getOrderList, updateOrderStatus } from "./orderSaga";
import moment from "moment";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import OrderStatusDialog from "./dialogs/OrderStatusDialog";
import SelectDropdown from "../../component-lib/Atoms/Select/Select";
import { ORDER_STATUS_FILTER, STATUS } from "./constant";
import { INVENTORY_TYPE_OPTIONS } from "../reports-screen/ReportConstants";
import { useNavigate } from "react-router-dom";

const OrdersScreen = () => {
  const { orderListData, closeOrderDialog } = useSelector(
    (state: any) => state[componentKey]
  );
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchedValue, setSearchValue] = useState<string>("");
  const [status, setStatus] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [inventoryType, setInventoryType] = useState("");
  const [isChangeStatus, setIsChangeStatus] = useState<any>({
    isChange: false,
    data: {},
  });

  console.log("orderListData:", orderListData);

  const deviceType = useDeviceType();

  // ORDER LIST COLUMN DATA
  const orderListColumns = [
    {
      field: "facilityName",
      label: <div>Facility Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.facilityName}</p>
        );
      },
    },
    {
      field: "orderId",
      label: <div>Order ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.orderId}</p>;
      },
    },
    {
      field: "itemName",
      label: <div>Item Name</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.itemName}</p>;
      },
    },
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.category}</p>;
      },
    },

    {
      field: "orderQuantity",
      label: <div>Order Quantity</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.orderQuantity}</p>
        );
      },
    },

    {
      field: "currentStock",
      label: <div>Current Stock</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.currentStock}</p>
        );
      },
    },

    {
      field: "orderDate",
      label: <div>Order Date</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.orderDate}</p>;
      },
    },
    {
      field: "orderStatus",
      label: <div>Order Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.orderStatus),
                background: getStatusBackground(row?.orderStatus),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.orderStatus),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.orderStatus)}
            </span>
          </div>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "Change Order Status",
                    onClickCb: () => {
                      setIsChangeStatus({
                        isChange: true,
                        data: row,
                      });
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // ORDER LIST ROW DATA
  const orderListRowData = orderListData?.data?.map((data: any) => {
    return {
      id: data?.id,
      facilityName: data?.facility?.name || "-",
      orderId: data?.orderId || "-",
      itemName: data?.inventory?.itemName || "-",
      category: data?.inventory?.type || "-",
      orderQuantity: data?.orderQuantity || "-",
      currentStock: data?.currentStock ?? "-",
      orderDate: data?.createdAt
        ? moment(data?.createdAt).format("MM/DD/YYYY")
        : "-",
      orderStatus: data?.orderStatus || "-",
      status: data?.status.split("_").join(" ") || "-",
    };
  });

  useEffect(() => {
    getOrder();
  }, [searchedValue, rowPerPage, pageNumber, orderStatus, status, inventoryType]);

  useEffect(() => {
    if (closeOrderDialog) {
      setIsChangeStatus({
        isChange: false,
        data: {},
      });
      dispatch(setCloseOrderDialog(false));
      getOrder();
    }
  }, [closeOrderDialog]);

  const getOrder = () => {
    try {
      const payload = {
        pageNumber: pageNumber,
        limit: rowPerPage,
        searchKey: searchedValue?.trim(),
        orderStatus: orderStatus ? orderStatus : "",
        status: status ? status : "",
        inventoryType: inventoryType ? inventoryType : "",
      };
      dispatch(getOrderList(payload));
    } catch (err) {
      console.log("error:", err);
    }
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  const handleOrderChange = (data: any) => {
    const apiPayload = {
      payload: {
        status: data?.orderStatus || undefined,
        orderQuantity: data?.orderQuantity
          ? Number(data.orderQuantity)
          : undefined,
      },
      id: isChangeStatus?.data?.id,
    };
    dispatch(updateOrderStatus(apiPayload));
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full min-w-0 gap-3">
        <div
          className={`flex flex-wrap gap-3 ${deviceType === "mobile" ? "flex-col items-start" : "items-center"} justify-between w-full`}
        >
          <Heading
            title={TEXT_CONSTANTS?.ORDERS_LIST}
            customStyle={{ color: "#1D1D1D" }}
          />

          <div
            className={`flex flex-wrap items-center gap-3 w-full xl:w-auto xl:justify-end ${deviceType === "mobile" ? "justify-between" : ""}`}
          >
            <div className="w-full sm:w-[220px]">
              <SelectDropdown
                label=""
                name="orderStatus"
                placeholderValue="All Order Status"
                displayEmpty={true}
                value={orderStatus}
                options={ORDER_STATUS_FILTER}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setOrderStatus(e.target.value);
                }}
              />
            </div>
            <div className="w-full sm:w-[220px]">
              <SelectDropdown
                label=""
                name="status"
                placeholderValue="All Status"
                displayEmpty={true}
                value={status}
                options={STATUS}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setStatus(e.target.value);
                }}
              />
            </div>
            <div className="w-full sm:w-[220px]">
              <SelectDropdown
                label=""
                name="inventoryType"
                placeholderValue="Select Category"
                displayEmpty={true}
                value={inventoryType}
                options={INVENTORY_TYPE_OPTIONS.filter((o) => o.value)}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setInventoryType(e.target.value);
                }}
              />
            </div>
            <div>
              {/* Width comes from MUI sx inside the component, so size it here. */}
              <div className="w-full sm:w-[300px]">
                <SearchSelectDropdown
                  freeSolo={true}
                  searchedValue={searchedValue}
                  onSearchValueChangeCb={(e) => handleChange(e)}
                  size="small"
                  label="Search By Item Name"
                  fullWidth="100%"
                  startIcon={
                    <img
                      alt="search-icon"
                      src={searchIcon}
                      width={"18px"}
                      height={"18px"}
                    />
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full min-w-0" style={{ overflow: "auto" }}>
          <Table
            columns={orderListColumns}
            rows={orderListRowData}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: orderListData?.totalPages,
              totalCount: orderListData?.totalRecords,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {isChangeStatus?.isChange && (
        <OrderStatusDialog
          defaultSelectedData={isChangeStatus}
          handleClose={() => {
            setIsChangeStatus({
              isChange: false,
              data: {},
            });
          }}
          handleData={(values) => {
            handleOrderChange(values);
          }}
          isOpen={isChangeStatus?.isChange}
          label="Change Order Status"
        />
      )}
    </WrapperCard>
  );
};

export default OrdersScreen;
